import {createFileRoute, SearchSchemaInput} from '@tanstack/react-router'
import LoginView from "../../LoginView.tsx";

export const Route = createFileRoute('/login/$subpage')({
    validateSearch: (search: Record<string, unknown> & SearchSchemaInput) => ({
        email: search.email as string | undefined,
        token: search.token as string | undefined,
        social: search.social as string | undefined,
    }),
  component: RouteComponent,
})

function RouteComponent() {
  return <LoginView />
}
